import { render, staticRenderFns } from "./modalCambiarLogo.vue?vue&type=template&id=26339cc8"
import script from "./modalCambiarLogo.vue?vue&type=script&lang=js"
export * from "./modalCambiarLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports